
import { types, actions } from './requests'
export const CREATEVARIANT_TYPES = {
    ...types('CREATEVARIANT'),
}
export const CREATEVARIANT_ACTIONS = {
    ...actions('CREATEVARIANT'),
}